import moment from "moment-timezone";
import DataTable from "react-data-table-component";
import { useHistory } from "react-router-dom";
import placeholder from "../../assets/images/fashion/product/12.jpg";

const BannerList = ({ bannerData, setOpen, setActiveId }) => {
  const columnDefs = [
    {
      name: "Banner",
      cell: (row) => <BannerImage row={row} />,
    },
    {
      name: "Title",
      selector: (row) => row?.title || row?.name,
      sortable: true,
    },
    {
      name: "Date",
      selector: (row) => moment(row?.createdAt).format("DD/MM/YYYY HH:mm"),
      sortable: true,
      maxWidth: "auto",
    },
    {
      name: "Actions",
      cell: (row) => (
        <ActionButton
          row={row}
          handleDelete={handleDelete}
          handleEdit={handleEdit}
        />
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      minWidth: "150px",
    },
  ];

  const history = useHistory();

  const handleEdit = (id) => {
    history.push(`/add-banner?id=${id}`);
  };

  const handleDelete = (id) => {
    setActiveId(id);
    setOpen(true);
  };

  return (
    <div className="table-responsive">
      <DataTable
        data={bannerData || []}
        columns={columnDefs}
        pagination
        selectableRows={false}
        onSelectedRowsChange={(e) => console.log("Selected Rows:", e)}
      />
    </div>
  );
};

export default BannerList;

const ActionButton = ({ row, handleDelete, handleEdit }) => {
  return (
    <div className="action-btn">
      {
        <span>
          <i
            onClick={() => handleDelete(row._id)}
            className="fa fa-trash"
            style={{
              width: 35,
              fontSize: 20,
              padding: 11,
              color: "#e4566e",
            }}></i>
        </span>
      }
      {
        <span>
          <i
            onClick={() => handleEdit(row._id)}
            className="fa fa-pencil"
            style={{
              width: 35,
              fontSize: 20,
              padding: 11,
              color: "rgb(40, 167, 69)",
            }}></i>
        </span>
      }
    </div>
  );
};

const BannerImage = ({ row }) => {
  return (
    <div className="banner-image">
      <img src={row.image ? row.image : placeholder} alt="logo" />
    </div>
  );
};
